import { render, staticRenderFns } from "./SolicitarTrocarSenha.vue?vue&type=template&id=40f70120&scoped=true&"
import script from "./SolicitarTrocarSenha.vue?vue&type=script&lang=js&"
export * from "./SolicitarTrocarSenha.vue?vue&type=script&lang=js&"
import style0 from "./SolicitarTrocarSenha.vue?vue&type=style&index=0&id=40f70120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f70120",
  null
  
)

export default component.exports